import { SaveOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import styled from 'styled-components'

const SaveWhiteBtn = (props) => {
  let {
    loading = false, onClick,
    disabled = false,
  } = props

  let content
  let click
  if (loading === false) {
    content = <SaveOutlined />
    click = onClick
  }
  return (
    <Page>
      <Button
        shape="circle" disabled={disabled}
        loading={loading} onClick={click}>
        {content}
      </Button>
    </Page>
  )
}

const Page = styled.div`
  button {
    color: #3F3F3F;
    background-color: white;
    border: 2px solid #F1FEFF;
    height: 45px
    width: 45px;
  }

  button > i {
    font-size: 16px;
  }

  button:hover {
    color: black;
    background-color: white;
    border-color: #dcedc2;
  }
`

export default SaveWhiteBtn
